import { Route } from '@angular/router'
import { _numberEnumValues } from '@naturalcycles/js-lib'
import {
  BreakpointAction,
  ChoiceFunction,
  ConceiveTimingBreakpointOption,
  GoalBreakpointOption,
  QuizDataInput,
  shortQuizGoalOptions,
} from '@naturalcycles/shared'
import { addPageInSectionAfterPage } from '@src/app/core/util/quiz.util'
import { Page } from '@src/app/shared/typings/enum/pages'
import { DefaultSections } from '@src/app/shared/typings/enum/quiz'

export const ab396Routes: Route[] = [
  {
    path: 'country-certifications',
    loadComponent: () =>
      import('./country-certifications/country-certifications.page.component').then(
        m => m.CountryCertificationsPage,
      ),
  },
]

export function getAb396GoalTransformFunction(
  existingChoiceFunction: ChoiceFunction<Page, QuizDataInput> | undefined,
  goal: GoalBreakpointOption,
): ChoiceFunction<Page, QuizDataInput> {
  return (flow, data) => {
    flow = existingChoiceFunction?.(flow, data) || flow
    if (shortQuizGoalOptions.includes(goal)) {
      return flow
    }

    flow = addPageInSectionAfterPage(
      flow,
      Page.countryCertifications,
      Page.fertilityGoalInfo,
      DefaultSections.goal,
    )
    return flow
  }
}

export function getAb396ConceiveTimingTransformFunction(
  existingChoiceFunction: ChoiceFunction<Page, QuizDataInput> | undefined,
): ChoiceFunction<Page, QuizDataInput> {
  return (flow, data) => {
    flow = existingChoiceFunction?.(flow, data) || flow
    flow = addPageInSectionAfterPage(
      flow,
      Page.countryCertifications,
      Page.fertilityGoalInfo,
      DefaultSections.goal,
    )
    return flow
  }
}

export function getAb396GoalBreakpointAction(
  existingBreakpointAction: BreakpointAction<GoalBreakpointOption, Page, QuizDataInput> | undefined,
): BreakpointAction<GoalBreakpointOption, Page, QuizDataInput> {
  return {
    ...Object.fromEntries(
      _numberEnumValues(GoalBreakpointOption).map(v => {
        return [v, getAb396GoalTransformFunction(existingBreakpointAction?.[v], v)]
      }),
    ),
  }
}

export function getAb396ConceiveTimingBreakpointAction(
  existingBreakpointAction:
    | BreakpointAction<ConceiveTimingBreakpointOption, Page, QuizDataInput>
    | undefined,
): BreakpointAction<ConceiveTimingBreakpointOption, Page, QuizDataInput> {
  return {
    ...Object.fromEntries(
      _numberEnumValues(ConceiveTimingBreakpointOption).map(v => {
        return [v, getAb396ConceiveTimingTransformFunction(existingBreakpointAction?.[v])]
      }),
    ),
  }
}
